import { useEffect } from 'react';
import { useDatasetFormData } from '../../../hooks/context/useDatasetFormData';
import { useFormTokenChainContext } from '../../../hooks/context/useFormTokenChainContext';
import { focusFormFieldByName } from '../../../utils/forms/focusFormFieldByName';

// Focuses the originating reference field after a fullscreen reference is closed/cancelled.
// Waits until the form has finished loading so the field is in the DOM.
export const usePendingFocusField = (): void => {
  const { form, actualToken, isLoading } = useDatasetFormData();
  const { updateTokenValues } = useFormTokenChainContext();

  useEffect(() => {
    const field = actualToken?.meta?.pendingFocusField;
    if (
      typeof field !== 'string' ||
      isLoading ||
      !form?.items?.length ||
      !actualToken
    ) {
      return;
    }

    // Suppress open-on-focus so the reference field doesn't reopen its popover.
    focusFormFieldByName(field, { suppressOpenOnFocus: true });

    const nextMeta = { ...(actualToken.meta ?? {}) };
    delete (nextMeta as Record<string, unknown>).pendingFocusField;
    updateTokenValues({ ...actualToken, meta: nextMeta });
  }, [actualToken, form, isLoading, updateTokenValues]);
};
